import React, { Component, Suspense } from "react";
import Slider from "react-slick";
import "../common/index.scss";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
// import custom Components
import Breadcrumb from "../common/breadcrumb";
import DetailsWithPrice1688 from "./common/product/details-price-1688";
import BuyAndShipForMe from "../layouts/homePage/buyAndShipForMe.png";
import DetailsTopTabsApi from "./common/details-top-tabs-api";
import {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
  fetchSingleProduct,
  setSearchedProductsArray,
} from "../../actions";

import ImageZoom from "./common/product/image-zoom";
import SmallImages from "./common/product/small-image";
import { addWishlistTofirestore } from "../../firebase/firebase.utils";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import "./singleProduct.css";
import RelatedProduct from "./common/product/relatedProduct";
import "./no-sidebar.css";

import Axios from "axios";
import { ClipLoader } from "react-spinners";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const ReactPlayer = React.lazy(() => import("react-player"));
const productCache = {};
class NoSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: this.slider1,
      colorVariantImage: "",
      item: null,
      searchBarValue: "",
      imgLoading: false,
    };
  }

  componentDidMount = async () => {
    const itemId = this.props.match.params.id;
    console.log(productCache);
    // Check cache first
    if (productCache[itemId]) {
      this.setState({
        nav1: this.slider1,
        item: productCache[itemId],
      });
    } else {
      try {
        console.log(process.env.NODE_ENV);
        let link = `https://alg.com.bd/api/products/${itemId}`;
        if (process.env.NODE_ENV === "production") {
          link = `/api/products/${itemId}`;
        }
        const response = await Axios.get(link);
        console.log(link);
        console.log(response.data);
        productCache[itemId] = response.data; // Store in cache

        this.setState({
          nav1: this.slider1,
          item: response.data,
        });
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    }
  };

  componentWillReceiveProps = async (nextProps) => {
    const newItemId = nextProps.match.params.id;
    console.log(productCache);
    if (this.props.match.params.id !== newItemId) {
      this.setState({ item: null });

      // Check cache for new item
      if (productCache[newItemId]) {
        this.setState({ item: productCache[newItemId] });
      } else {
        try {
          let link = `https://alg.com.bd/api/products/${newItemId}`;
          if (process.env.NODE_ENV === "production") {
            link = `/api/products/${newItemId}`;
          }
          const response = await Axios.get(link);

          productCache[newItemId] = response.data; // Cache new item

          this.setState({
            item: response.data,
          });
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      }
    }
  };

  addToReduxAndFirestoreCart = async (product) => {
    const { addToCart, currentUser, currency } = this.props;
    let taka = 0;
    if (currency.taka) {
      taka = currency.taka;
    }
    console.log("add to redux and firestore cart is getting called");
    console.log(product);
    await addToCart(currentUser, { ...product, currency: taka });
    toast.success("Added to Cart");
  };
  addToReduxAndFirestoreWishlist = async (product) => {
    const { addToWishlist, currentUser } = this.props;
    console.log(this.props);
    if (currentUser && currentUser.uid) {
      console.log(product);
      // Remove undefined/null values
      const cleanProduct = Object.fromEntries(
        Object.entries(product).filter(([key, value]) => value != null),
      );

      await addWishlistTofirestore(currentUser, cleanProduct);
      toast.success("Item addded to wishilist");
    } else {
      alert("You must login first.");
    }
  };

  clickOnColorVariant = (imgUrl) => {
    this.setState({ colorVariantImage: imgUrl, playVideo: false });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  getProductId = (url) => {
    try {
      const parsedUrl = new URL(url);

      // Case 1: Mobile link (ID in query param)
      const offerId = parsedUrl.searchParams.get("offerId");
      if (offerId) return offerId;

      // Case 2: Desktop link (ID in pathname)
      const pathMatch = parsedUrl.pathname.match(/\/(\d+)\.html/);
      if (pathMatch) return pathMatch[1];

      return null;
    } catch (err) {
      console.error("Invalid URL");
      return null;
    }
  };
  handleSearchBarSubmit = (event) => {
    event.preventDefault();
    if (this.state.searchBarValue.length < 35) {
      var win = window.open(
        `${process.env.PUBLIC_URL}/collection/${this.state.searchBarValue}`,
        "_blank",
      );
      win.focus();
    } else {
      this.props.setSearchedProductsArray(0, []);
      if (this.state.searchBarValue.includes("1688")) {
        let productId = this.getProductId(this.state.searchBarValue);
        console.log(productId);

        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${productId}`,
          "_blank",
        );
        win.focus();
      } else {
        let taobaoUrl = new URL(this.state.searchBarValue);
        let params = taobaoUrl.search;
        const urlParams = new URLSearchParams(params);
        const id = urlParams.get("id");
        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${id}`,
          "_blank",
        );
        win.focus();
      }
    }
    this.setState({ searchBarValue: "" });
  };

  openPage = (imgUrl) => {
    this.props.history.push(
      `${process.env.PUBLIC_URL}/collection/img_uploads?imageUrl=${imgUrl}`,
    );
  };

  resizeAndCompressImage = (
    file,
    maxWidth = 500,
    maxHeight = 500,
    quality = 0.7,
  ) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        let { width, height } = img;

        // Maintain aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Compress image to JPEG format
        const compressedBase64 = canvas.toDataURL("image/jpeg", quality); // quality from 0 to 1
        resolve(compressedBase64.split(",")[1]); // remove 'data:image/jpeg;base64,'
      };

      img.onerror = (err) => {
        reject(err);
      };
    });
  };

  handleImgChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    this.setState({
      imgLoading: true,
    });

    // 👇 Get Data URL for preview (not the same as pure base64 for upload)
    const reader = new FileReader();
    reader.onload = () => {
      const imageDataUrl = reader.result; // includes "data:image/jpeg;base64,..."
      localStorage.setItem("uploadedImagePreview", imageDataUrl); // 🧠 Persist it
      this.setState({ imageUrl: imageDataUrl }); // Show it
    };
    reader.readAsDataURL(file);

    const base64 = await this.resizeAndCompressImage(file);

    console.log(base64);
    if (base64 === this.state.lastImageBase64) {
      console.log("Image is the same, skipping upload.");
      return;
    }

    this.setState({ lastImageBase64: base64 });
    let link = `https://alg.com.bd/api/products/upload-image`;
    if (process.env.NODE_ENV === "production") {
      link = `/api/products/upload-image`;
    }
    const resultObj = await Axios.post(link, {
      imageBase64: base64,
    });
    console.log(resultObj);
    if (
      resultObj.data &&
      resultObj.data.result &&
      resultObj.data.result.result
    ) {
      this.setState({ imgLoading: false });
      this.openPage(resultObj.data.result.result);
    } else {
      this.setState({ imgLoading: false });
      alert("There was an error uploading your image.");
    }
  };

  render() {
    const {
      symbol,

      addToCart,
      addToCartUnsafe,
      addToWishlist,
    } = this.props;
    const { item } = this.state;

    var products = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      fade: true,
    };

    var productsnav = {
      arrows: true,
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: true,
      prevArrow: "",
      nextArrow: "",
      edgeFriction: 0,
      responsive: [
        { breakpoint: 375, settings: { slidesToShow: 4 } },
        { breakpoint: 450, settings: { slidesToShow: 5 } },
        { breakpoint: 1024, settings: { slidesToShow: 5 } },
        { breakpoint: 1500, settings: { slidesToShow: 5 } },
        { breakpoint: 1600, settings: { slidesToShow: 6 } },
        { breakpoint: 25000, settings: { slidesToShow: 7 } },
        { breakpoint: 100000, settings: "unslick" },
      ],
    };

    console.log(window.innerWidth);
    console.log(item?.videos);
    console.log(item);
    console.log(this.state.colorVariantImage);

    return (
      <div>
        <Helmet>
          <title>{item ? item.name : this.props.match.params.id}</title>
        </Helmet>
        <ToastContainer />
        {window.innerWidth > 600 ? (
          item ? (
            <Breadcrumb title={item.name} />
          ) : (
            ""
          )
        ) : null}
        {/*Section Start*/}
        {item ? (
          <>
            <div
              className="top-searchbar-parent webview-hidden"
              style={{ background: "white" }}
            >
              <div className="top-searchbar-container-2">
                <form
                  className="form_search top-form form-search2"
                  role="form"
                  onSubmit={this.handleSearchBarSubmit}
                  style={{
                    borderRadius: "0px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <input
                    id="query search-autocomplete"
                    type="search"
                    placeholder="Search 100+ millions of products"
                    value={this.state.searchBarValue}
                    onChange={this.handleChange}
                    name="searchBarValue"
                    className="nav-search nav-search-field"
                    aria-expanded="true"
                    style={{ color: "black" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      className="btn-search"
                      style={{
                        width: "40px",
                        position: "relative",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{
                          color: "#ff4c3b",
                          marginTop: 12,
                          fontSize: "150%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          window.document
                            .getElementById("upload-image-input13")
                            .click();
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      style={{
                        position: "relative",
                        backgroundColor: "#ff4c3b",
                        minHeight: "100%",
                        marginTop: -5,
                        marginRight: -5,
                        borderRadius: 0,
                      }}
                      onClick={this.handleSearchBarSubmit}
                    >
                      {this.state.imgLoading ? (
                        <ClipLoader
                          loading={this.state.imgLoading}
                          color="white"
                          size={20}
                        />
                      ) : (
                        <i
                          className="fa fa-search"
                          style={{
                            color: "white",
                            margin: "auto",
                            padding: "5px 13px",
                            fontSize: "120%",
                          }}
                        />
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <section
              className="product-container-section"
              style={{
                margin: "auto",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <div className="collection-wrapper">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 product-thumbnail">
                      {this.state.colorVariantImage && !this.state.playVideo ? (
                        <ImageZoom image={this.state.colorVariantImage} />
                      ) : item.videos &&
                        item.videos.length > 0 &&
                        item.videos[0].Url ? (
                        <div
                          className="image-container"
                          style={{
                            border: "2px solid gainsboro",
                            borderRadius: 5,
                            justifyContent: "center",
                            alignItems: "center",
                            alignContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <Suspense fallback={<div>Loading player...</div>}>
                            <ReactPlayer
                              url={item.videos[0].Url}
                              height={"100%"}
                              width={"100%"}
                              light={
                                item.videos[0].PreviewUrl
                                  ? item.videos[0].PreviewUrl
                                  : this.state.videoThumdnail
                                    ? this.state.videoThumdnail
                                    : this.state.colorVariantImage
                              }
                              controls={true}
                              playing={false}
                            />
                          </Suspense>
                        </div>
                      ) : (
                        <>
                          <ImageZoom
                            image={
                              item.pictures.length > 0 ? item.pictures[0] : ""
                            }
                          />
                        </>
                      )}
                      <SmallImages
                        item={item}
                        navOne={this.state.nav1}
                        clickOnColorVariant={this.clickOnColorVariant}
                        clickOnVideo={(videoThumdnail) => {
                          this.setState({
                            playVideo: true,
                            videoThumdnail,
                          });
                        }}
                      />
                      <div style={{ marginTop: 30, marginLeft: 10 }}>
                        <p className="service-list">
                          <span>&#10003;</span> 24/7 online services for our
                          customers via wechat,whatsapp, hotline and facebook.{" "}
                          <br />
                          <span>&#10003;</span> The best wholesale prices and a
                          vast variety of goods.
                          <br />
                          <span>&#10003;</span> live tracking your product 24/7.
                          <br />
                          <span>&#10003;</span> 100% Secure payment with us.{" "}
                          <br />
                          <span>&#10003;</span> Fastest product delivery(around
                          15-20 working days). <br />
                          <span>&#10003;</span> Cheapest shipping charges around
                          the country.
                          <br />
                          <span>&#10003;</span> Claiming 100% refund facility.
                          <Link
                            to={`${process.env.PUBLIC_URL}/pages/refund-policy`}
                            style={{ fontSize: "80%", color: "orange" }}
                          >
                            see refund policy
                          </Link>
                          <br />
                        </p>
                      </div>
                      <div>
                        <div style={{ fontWeight: "bold", marginTop: 20 }}>
                          How buy and ship for me works
                        </div>
                        <div>
                          <img
                            src={BuyAndShipForMe}
                            style={{
                              width: "100%",
                              borderRadius: 10,
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <DetailsWithPrice1688
                      {...this.props}
                      symbol={symbol}
                      item={item}
                      navOne={this.state.nav1}
                      clickOnColorVariant={this.clickOnColorVariant}
                      addToCartClicked={this.addToReduxAndFirestoreCart}
                      BuynowClicked={addToCartUnsafe}
                      addToWishlistClicked={this.addToReduxAndFirestoreWishlist}
                    />
                  </div>
                </div>
              </div>
            </section>

            {/*Section End*/}

            {item.relatedGroups && item.relatedGroups.length > 0 && (
              <section className="tab-product m-0">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12 col-lg-12">
                      <RelatedProduct
                        type={"others"}
                        status={"in-stock"}
                        title="Similar Products"
                        subtitle="Suppliers"
                        item={item}
                      />
                    </div>
                  </div>
                </div>
              </section>
            )}

            <section
              className="tab-product"
              style={{
                marginTop: item?.variants && item.variants.length > 2 ? 0 : 100,
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 col-lg-12">
                    <DetailsTopTabsApi item={item} />
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          // for skeleton
          <>
            <div
              className="top-searchbar-parent webview-hidden"
              style={{ background: "white" }}
            >
              <div className="top-searchbar-container-2">
                <form
                  className="form_search top-form form-search2"
                  role="form"
                  onSubmit={this.handleSearchBarSubmit}
                  style={{
                    borderRadius: "0px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <input
                    id="query search-autocomplete"
                    type="search"
                    placeholder="Search 100+ millions of products"
                    value={this.state.searchBarValue}
                    onChange={this.handleChange}
                    name="searchBarValue"
                    className="nav-search nav-search-field"
                    aria-expanded="true"
                    style={{ color: "black" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      className="btn-search"
                      style={{
                        width: "40px",
                        position: "relative",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{
                          color: "#ff4c3b",
                          marginTop: 12,
                          fontSize: "150%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          window.document
                            .getElementById("upload-image-input13")
                            .click();
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      style={{
                        position: "relative",
                        backgroundColor: "#ff4c3b",
                        minHeight: "100%",
                        marginTop: -5,
                        marginRight: -5,
                        borderRadius: 0,
                      }}
                      onClick={this.handleSearchBarSubmit}
                    >
                      {this.state.imgLoading ? (
                        <ClipLoader
                          loading={this.state.imgLoading}
                          color="white"
                          size={20}
                        />
                      ) : (
                        <i
                          className="fa fa-search"
                          style={{
                            color: "white",
                            margin: "auto",
                            padding: "5px 13px",
                            fontSize: "120%",
                          }}
                        />
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <section
              className="product-container-section"
              style={{
                margin: "auto",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <div className="collection-wrapper">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 product-thumbnail">
                      <div
                        style={{
                          width: "100%",
                        }}
                        className="skeleton-main-image"
                      >
                        <Skeleton width={"100%"} height={"100%"} />
                      </div>

                      <div className="small-image-container-div">
                        <Slider
                          {...productsnav}
                          asNavFor={this.props.navTwo}
                          ref={(slider) => (this.slider2 = slider)}
                          className="slider-nav"
                        >
                          {[1, 2, 3, 4, 5, 6, 7].map((vari, index) => (
                            <div
                              key={index}
                              style={{
                                cursor: "pointer",
                                overflow: "hidden",
                              }}
                            >
                              <Skeleton height={60} width={60} />
                            </div>
                          ))}
                        </Slider>
                      </div>
                      <div style={{ marginTop: 30, marginLeft: 10 }}>
                        <p className="service-list">
                          <Skeleton />
                          <br />
                          <Skeleton />
                          <br />
                          <Skeleton />
                          <br />
                          <Skeleton />
                          <br />
                          <Skeleton /> <br />
                          <Skeleton />
                          <br />
                        </p>
                      </div>
                      <div>
                        <div style={{ fontWeight: "bold", marginTop: 20 }}>
                          <Skeleton />
                        </div>
                        <div>
                          <Skeleton />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 rtl-text" style={{ padding: 0 }}>
                      <div className="product-right">
                        <h6 className="product-detail-title">
                          {" "}
                          <Skeleton />
                        </h6>

                        <div>
                          <h6 style={{ marginBottom: "0px", fontSize: 13 }}>
                            <Skeleton />
                          </h6>
                        </div>
                        <div className="star-containing-div">
                          <div>
                            <Skeleton />
                          </div>{" "}
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: "bold",
                              marginLeft: 5,
                            }}
                          >
                            <Skeleton />
                          </div>
                        </div>

                        {/* for showing price  */}

                        <h3 style={{}}>
                          <Skeleton />
                        </h3>

                        <div className="product-description border-product">
                          <div>
                            <div className="size-box">
                              <div className="size-category">
                                <div
                                  className="d-flex flex-row"
                                  style={{
                                    padding: "20px 10px",
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    borderBottom: "1px dotted gainsboro",
                                    background: "beige",
                                  }}
                                >
                                  <div
                                    className="size-price size-price2 col"
                                    style={{ fontWeight: "bold", fontSize: 12 }}
                                  >
                                    <Skeleton />
                                  </div>
                                  <div
                                    className="size-price col"
                                    style={{
                                      fontWeight: "bold",
                                      margin: "auto 0px",
                                      fontSize: 12,
                                      textAlign: "center",
                                    }}
                                  >
                                    <Skeleton />
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      margin: "auto 0px",
                                      fontSize: 12,
                                    }}
                                    className="size-price col"
                                  >
                                    <Skeleton />
                                  </div>

                                  <div
                                    style={{
                                      margin: "auto 0px",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      fontSize: 12,
                                    }}
                                    className="size-price col-5"
                                  >
                                    <Skeleton />
                                  </div>
                                </div>
                                {[1, 2, 3].map((sizeObj, i) => {
                                  return (
                                    <div
                                      className="d-flex flex-row"
                                      style={{
                                        padding: "20px 10px",
                                        display: "flex",
                                        flexDirection: "row",
                                        borderBottom: "1px dotted gainsboro",
                                      }}
                                      key={i}
                                    >
                                      <div className="col size-price">
                                        <span
                                          style={{
                                            padding: 10,
                                            height: 40,
                                            width: 40,
                                          }}
                                        >
                                          <Skeleton height={40} width={40} />
                                        </span>
                                      </div>
                                      <div
                                        className="size-price col"
                                        style={{
                                          fontWeight: "bold",
                                          margin: "auto 0px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Skeleton />
                                      </div>

                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          margin: "auto 0px",
                                          textAlign: "center",
                                        }}
                                        className="size-price col"
                                      >
                                        <Skeleton />
                                      </div>
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          margin: "auto 0px",
                                          textAlign: "center",
                                        }}
                                        className="size-price col"
                                      >
                                        <Skeleton />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="shipping-info-mobile-view">
                            <div
                              className="local-courier-charge-div"
                              style={{ marginBottom: 10, marginTop: 20 }}
                            >
                              <div className="form-group shipping-method">
                                <label style={{ marginBottom: 5 }}>
                                  <Skeleton />
                                  {/* <span style={{ fontWeight: "bold" }}>(for 5kg+)</span>: */}
                                </label>
                                <div style={{ position: "relative" }}>
                                  <Skeleton />
                                </div>
                              </div>
                            </div>
                            <div
                              className="local-courier-charge-div"
                              style={{ marginBottom: 10, marginTop: 20 }}
                            >
                              <div className="form-group shipping-method">
                                <div
                                  style={{
                                    textAlign: "left",
                                    padding: 12,
                                    color: "black",
                                    fontSize: 12,

                                    backgroundSize: "800% 800%",

                                    // animation: "glowBackground 5s ease infinite",
                                    borderRadius: 8,
                                    margin: "0px 10px",
                                  }}
                                >
                                  <Skeleton />
                                </div>
                                <div
                                  style={{
                                    textAlign: "left",
                                    padding: 12,
                                    color: "black",
                                    fontSize: 12,
                                    background:
                                      "linear-gradient(270deg, rgb(217 235 255), rgb(216 228 255)) 0% 0% / 800% 800%",
                                    backgroundSize: "800% 800%",
                                    border: "2px solid rgb(148 170 255)",
                                    // animation: "glowBackground 5s ease infinite",
                                    borderRadius: 8,
                                    margin: "0px 10px",
                                    marginTop: 10,
                                  }}
                                >
                                  <Skeleton />
                                </div>
                              </div>
                            </div>

                            <div
                              className="local-courier-charge-div"
                              style={{ marginBottom: 10, marginTop: 5 }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <Skeleton />
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <Skeleton />
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <Skeleton />
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <Skeleton />
                              </div>
                              <div
                                className="d-flex flex-row cn-key"
                                style={{
                                  textAlign: "left",
                                  justifyContent: "flex-start",
                                  padding: 7,
                                  border: "1px solid gainsboro",
                                }}
                              >
                                <Skeleton />
                              </div>

                              <div
                                style={{
                                  padding: 7,
                                  border: "1px solid gainsboro",
                                  paddingBottom: 23,
                                }}
                              >
                                <div
                                  className="d-flex flex-row cn-key"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <Skeleton />
                                </div>
                              </div>

                              <div
                                style={{
                                  padding: 7,
                                  border: "1px solid gainsboro",
                                }}
                              >
                                <div
                                  className="d-flex flex-row cn-key"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <Skeleton />
                                </div>
                              </div>
                              <div
                                style={{
                                  padding: 7,
                                  border: "1px solid gainsboro",
                                  paddingBottom: 43,
                                }}
                              >
                                <div
                                  className="d-flex flex-row cn-key"
                                  style={{
                                    textAlign: "left",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <Skeleton />
                                </div>
                                <div
                                  style={{
                                    float: "right",
                                    fontSize: 11,
                                    fontWeight: "bold",
                                  }}
                                  className="china-local"
                                >
                                  <Skeleton />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex flex-row product-buttons shipping-info-mobile-view">
                          <div style={{ padding: 10 }}>
                            <Skeleton />
                          </div>
                        </div>
                        <div
                          style={{
                            border: "1px dashed #dddddd",
                            marginBottom: 10,
                          }}
                        />
                        <div
                          className="border-product"
                          style={{
                            borderRadius: "7px",
                            boxShadow:
                              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                            background: "rgb(255, 255, 255)",
                            display: "inline-block",
                            paddingLeft: 20,
                            paddingRight: 20,
                            marginBottom: 20,
                            paddingBottom: 20,
                            marginTop: 5,
                            borderTop: "none",
                            width: "95%",
                          }}
                        >
                          <h6
                            className="product-title"
                            style={{
                              borderBottom: "1px dashed",
                              paddingBottom: "5px",
                            }}
                          >
                            <Skeleton />
                          </h6>
                          <div>
                            <Skeleton />
                          </div>

                          <div style={{}}>
                            <Skeleton />
                          </div>
                          <div
                            style={{
                              marginBottom: 5,
                            }}
                          >
                            <Skeleton />
                          </div>
                        </div>
                      </div>
                      <div
                        className="shipping-info-pc-view shipping-info-div"
                        style={{
                          position: "absolute",
                          top: -70,
                          right: "-100%",
                          padding: 20,
                          paddingTop: 30,
                          paddingBottom: 30,
                          borderRadius: "7px",
                          boxShadow:
                            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                          background: "rgb(255, 255, 255)",
                        }}
                      >
                        <div
                          className="local-courier-charge-div"
                          style={{
                            marginBottom: 10,
                            marginTop: 20,
                            paddingRight: 0,
                          }}
                        >
                          <div className="form-group shipping-method">
                            <div
                              style={{
                                textAlign: "center",

                                fontWeight: "bold",
                                padding: 12,
                                background: "beige",
                                color: "black",
                                fontSize: 12,
                              }}
                            >
                              <Skeleton />
                              {/* <span style={{ fontWeight: "bold" }}>(for 5kg+)</span>: */}
                            </div>
                            <div style={{ position: "relative" }}>
                              <Skeleton />
                            </div>
                          </div>
                        </div>
                        <div
                          className="local-courier-charge-div"
                          style={{
                            marginBottom: 10,
                            marginTop: 20,
                            paddingRight: 0,
                          }}
                        >
                          <div className="form-group shipping-method">
                            <div
                              style={{
                                textAlign: "left",
                                padding: 12,
                                color: "black",
                                fontSize: 12,
                                background:
                                  "linear-gradient(270deg, rgb(0 0 0), rgb(216, 255, 228)) 0% 0% / 800% 800%",
                                backgroundSize: "800% 800%",
                                border: "2px solid #94ffb6ff",
                                // animation: "glowBackground 5s ease infinite",
                                borderRadius: 8,
                              }}
                            >
                              <Skeleton />
                            </div>
                            <div
                              style={{
                                textAlign: "left",
                                padding: 12,
                                color: "black",
                                fontSize: 12,
                                background:
                                  "linear-gradient(270deg, rgb(217 235 255), rgb(216 228 255)) 0% 0% / 800% 800%",
                                backgroundSize: "800% 800%",
                                border: "2px solid rgb(148 170 255)",
                                // animation: "glowBackground 5s ease infinite",
                                borderRadius: 8,
                                marginTop: 10,
                              }}
                            >
                              <Skeleton />
                            </div>
                          </div>
                        </div>

                        <div
                          className="local-courier-charge-div"
                          style={{
                            marginBottom: 10,
                            marginTop: 5,
                            paddingRight: 0,
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Skeleton />
                          </div>
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Skeleton />
                          </div>
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Skeleton />
                          </div>
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Skeleton />
                          </div>
                        </div>

                        <div
                          style={{
                            justifyContent: "center",
                            width: "100%",

                            padding: 12,
                            border: "1px solid gainsboro",
                            borderRadius: 5,
                          }}
                        >
                          <Skeleton />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/*Section End*/}
          </>
        )}
        <input
          id="upload-image-input13"
          className="upload"
          type="file"
          accept="image/*"
          ref={this.fileInputRef}
          style={{
            position: "absolute",
            zIndex: 5,
            maxWidth: "50px",
            marginTop: "10px",
            display: "none",
          }}
          onChange={this.handleImgChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let productId = ownProps.match.params.id;
  return {
    symbol: state.data.symbol,
    currentUser: state.user.currentUser,
    currency: state.user.currency,
  };
};

export default connect(mapStateToProps, {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
  fetchSingleProduct,
  setSearchedProductsArray,
})(NoSideBar);
